/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import {
	InnerBlocks,
} from '@wordpress/block-editor';
import { Card } from '@wordpress/components';

/**
 * Inner dependencies.
 */
import Inspector from './inspector';
import Accordion from '../../components/Accordion';

const Edit = ( props ) => {
	const { className, isSelected, blockClientId } = props;

	const wrapperClasses = classnames(
		className,
		`gutenify-block-accordion-wrapper`,
		`gutenify-section-${ blockClientId }`,
	);
	return <div className={ wrapperClasses }>
		{ isSelected && <Inspector { ...props } /> }
		<Accordion tabs={ [
			{
				name: 'slider-edit',
				initialOpen: true,
				label: () => {
					return __( 'Edit Slide' );
				},
				cb: () => {
					return <>
						<Card>
							<InnerBlocks
								renderAppender={ () => {
									return <InnerBlocks.ButtonBlockAppender />;
								} }
							/>
						</Card>
					</>;
				},
			},
		] } />

	</div>;
};

export default Edit;
